<template>
  <div class="cm-field cm-chosen-field">
    <slot></slot>
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'javascripts/chosen'

  export default {
    mounted() {
      $(this.$el).children('select').chosen({
        allow_single_deselect: true,
        placeholder_text_single: "Select one"
      })
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/chosen-field.vue?3c33d0dc